import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import { setSubChildId } from "Administrator/modules/AdministratorModule";

export default store => ({
  path: "dashboard",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "./components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;

        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter() {
    store.dispatch(setSubChildId("INTEGRATIONS_DASHBOARD"));
  },
  onLeave() {
    store.dispatch(setSubChildId(""));
  },
});
